import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import ToolbarTool from '../../../ToolbarTool';
import useSheet from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import ColorToolIcon from '../../colorTools/ColorToolIcon';
import { getSelectedLabelId, selectUsableLabels } from '../../../../../../element/labels/labelSelectors';
import { getColorDisplayValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import SheetContainer, { Content, Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import LabelColorPicker from '../components/LabelColorPicker';

import '../../colorTools/popup/mobile/MobileColorToolContent.scss';

type MobileLabelColorToolProps = {
    name: string;
};

const MobileLabelColorTool = ({ name }: MobileLabelColorToolProps): ReactElement | null => {
    const sheetProps = useSheet(SheetId.LabelColorTool);
    const selectedLabelId = useSelector(getSelectedLabelId);
    const labels = useSelector(selectUsableLabels);
    const selectedLabel = selectedLabelId ? labels?.[selectedLabelId] : undefined;

    if (!selectedLabel) return null;

    return (
        <>
            <ToolbarTool name={name} isOpen={sheetProps.isSheetOpen} onClick={sheetProps.dispatchOpenSheet}>
                <ColorToolIcon
                    key={`label-color-${selectedLabel._id}`}
                    supportColorBar={false}
                    supportBackgroundColor={false}
                    selectedType={undefined}
                    color={getColorDisplayValue(selectedLabel.color)}
                    isActive={sheetProps.isSheetOpen}
                />
            </ToolbarTool>
            <SheetContainer className="LabelColorSheet color-tool" {...sheetProps}>
                <Overlay />
                <Sheet>
                    <Content>
                        <LabelColorPicker
                            label={selectedLabel}
                            isActive={sheetProps.isSheetOpen}
                            customColorInputClassName="custom-color-picker-input absolute top-0 left-0 opacity-0 pointer-events-none"
                        />
                    </Content>
                </Sheet>
            </SheetContainer>
        </>
    );
};

export default MobileLabelColorTool;
